import { useForm } from '@nerdgeschoss/react-use-form-library';
import React from 'react';
import { FormCheckbox } from '../../../../../components/Form/Checkbox/FormCheckbox';
import { FormForm } from '../../../../../components/Form/FormForm';
import GlobalProps from '../../../../../components/globalProps';
import { Stack } from '../../../../../components/Stack/Stack';
import { t } from '../../../../../locales/translate';
import { EVENT_SCANNER_CODE_TYPES, updateEventScannerCodeTypes } from '../../../../../model/event';
import { handleError } from '../../../../../model/notification';
import { EventScannerCodeType } from '../../../../../generated/graphql';

interface Props extends GlobalProps {
  eventId: string;
  codeTypes: EventScannerCodeType[];
  onClose: () => void;
}

export function ScannerCodeTypesForm({ eventId, codeTypes, onClose }: Props): JSX.Element {
  const { model, fields, dirty, onSubmit, submissionStatus } = useForm({
    model: { codeTypes },
    onSubmit: async () => {
      await updateEventScannerCodeTypes(eventId, model.codeTypes);
      onClose();
    },
    onSubmitError: (error) => handleError(error),
  });

  return (
    <FormForm onSubmit={onSubmit} onClose={onClose} canSubmit={dirty} loading={submissionStatus === 'submitting'}>
      <Stack>
        {EVENT_SCANNER_CODE_TYPES.map((codeType) => (
          <FormCheckbox
            verticalAlign="top"
            key={codeType}
            value={fields.codeTypes.value.includes(codeType)}
            onChange={(change) => {
              if (change) {
                fields.codeTypes.add(codeType);
              } else {
                fields.codeTypes.elements.find((r) => r.value === codeType)?.remove();
              }
            }}
            label={
              <Stack size="xs">
                <strong>{t.model.event._codeTypes[codeType].label}</strong>
                <small>{t.model.event._codeTypes[codeType].description}</small>
              </Stack>
            }
          />
        ))}
      </Stack>
    </FormForm>
  );
}
